import { Component, OnInit } from '@angular/core';
import {
  DetailSearchConfiguration,
  SearchRequest,
  SearchService,
  Session,
  TranslationService,
} from 'src/app/my-sedgwick';
import { BaseComponent, LoadingState, SearchResult } from 'src/app/shared';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { UserActions } from 'src/app/shared/models/user';

@Component({
    selector: 'app-open-claims-page',
    template: `
    <app-section>
      <div class="app-pl2 tw-w-full">
        <app-claim-breadcrumb></app-claim-breadcrumb>
      </div>
      <app-panel
        [title]="'Open claims'"
        [headerLevel]="1"
        [canExpand]="false"
        class="tw-w-full"
      >
        <div class="tw-min-h-[510px] tw-w-full">
          <app-detail-search-form
            #searchForm
            [config]="config"
            (search)="search($event)"
            [loading]="loading"
            [translationRequest]="translationRequest"
          >
            <ng-template #results>
              <app-search-count-row
                [count]="openClaims.length"
                [isInDirectInclude]="isInDirectReporting"
                [isSupervisor]="isSupervisorSelect"
                [supervisorFullName]="SupervisorFullName"
              ></app-search-count-row>              
              <app-search-results-list
                [searchResults]="openClaims"
                [hideCustomFields]="true"
                class="tw-w-full"
                (export)="searchForm.appendExport($event)"
                excelName="Open Claims"
                sheetName="Open Claims"
                [translationRequest]="translationRequest"
              />
            </ng-template>
          </app-detail-search-form>
        </div>
      </app-panel>
    </app-section>
  `,
    styles: ``,
    standalone: false
})
export class OpenClaimsPageComponent extends BaseComponent implements OnInit {
  userAction = UserActions.ViewOwnMgrDb;
  config = new DetailSearchConfiguration();
  loading: LoadingState;
  openClaims: SearchResult[];
  isSupervisorSelect : boolean = false;
  SupervisorFullName : string = '';
  isInDirectReporting : boolean = true;
  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Search',
    subGroup: 'Search',
  });

  constructor(
    private searchService: SearchService,
    private translationService: TranslationService,
    private session: Session) {
    super();
    this.config.key = 'omni-dashboard:open-claims';
    this.config.ssn.visible = false;
    this.config.status.visible = false;
    this.config.employeeId.widthPercent = 25;
    this.config.initialSearch = true;
    this.config.initialSearchResultsOnClear = true;
    this.config.managerLookupSupervisor = false;
    this.config.showParametersToggle = true;
    this.config.expanded = false;
    this.config.payType.visible = false;
    this.config.includeIndirect.visible = false;
  }

  loadTranslations(): void {
    this.translationRequest.contNum = Number(this.session.user.contNum);
    this.translationService.getTranslation(this.translationRequest);
  }

  ngOnInit(): void {
    this.loadTranslations();
    this.config.lob.widthPercent = 33;
    this.config.startDate.widthPercent = 33;
    this.config.endDate.widthPercent = 33;
    this.config.supervisor.visible = false;

    const includeIndirect = this.verifyIndirectReport();
    this.config.initialValue = { includeIndirectReports: includeIndirect };

    if(this.verifyFilterByManager())
    {
      this.isSupervisorSelect = this.verifyFilterByManager();
       const filteredManagerInSession = sessionStorage.getItem(
        this.session.user.sessionId + 'filteredManager_summary');
      const supervisor = JSON.parse(filteredManagerInSession);
      this.SupervisorFullName = supervisor.name;
      this.isInDirectReporting = includeIndirect;
    }

    this.config.initialSearch = true;
  }

  override ngOnDestroy(): void {
    this.config.initialSearch = true;
  }

  async search(request: SearchRequest) {
    this.loading = 'Loading';
    const params = request.getParameters();
    if (this.verifyFilterByManager()) {
      const filteredManagerInSession = sessionStorage.getItem(
        this.session.user.sessionId + 'filteredManager_summary');
      const supervisor = JSON.parse(filteredManagerInSession);
      params.supervisor = supervisor;
      params.managerEmpUnum = supervisor.empUnum;
    }
    else
    {
      params.managerEmpUnum = null;
    }

    params.includeIndirectReports = this.verifyIndirectReport();
    
    params.status = ['O', 'I'];
    params.excludeSupervisor = true;
    const searchInformation = await this.searchService.getSearchResults(params);
    this.openClaims = searchInformation.searchResults;
    this.loading = this.openClaims.length > 0 ? 'Loaded' : 'Empty';
    this.config.initialSearch = false;
  }

  verifyIndirectReport() {
    const includeIndirectsInSession = sessionStorage.getItem(
      this.session.user.sessionId + 'includeIndirects_summary'
    );

    if (includeIndirectsInSession == undefined || includeIndirectsInSession == null || includeIndirectsInSession.length < 2) {
      return false;
    }
    else {
      return includeIndirectsInSession == 'true';
    }


  }
  verifyFilterByManager() {
    const filteredManagerInSession = sessionStorage.getItem(
      this.session.user.sessionId + 'filteredManager_summary'
    );

    if (filteredManagerInSession == undefined || filteredManagerInSession == null || filteredManagerInSession.length < 2) {
      return false;
    }
    else {
      return true;
    }
  }

}
